import {
  PalletRouteRow,
  PalletRouteSummary,
} from "../../types/pallet-summary.type";
import NoteCell from "../SaleDepositReport/NoteCell";
import PalletTable, { PalletColumn, detailColumn } from "./PalletTable";
import { NOTE_LABEL, NOTE_MAX_WIDTH } from "./constants";
import {
  formatNames,
  formatRouteNotes,
  formatUnexplainedTrips,
  routeLabel,
} from "./palletSummary";

const LEAD_COLUMNS: PalletColumn<PalletRouteRow>[] = [
  { label: "สายส่ง", render: routeLabel },
  { label: "พนักงานขาย", render: (route) => formatNames(route.salespeople) },
  { label: "รถ", render: (route) => formatNames(route.vehicle_plates) },
];

/** Read-only for every role: a note is written on its trip, one level down. */
const NOTE_COLUMN: PalletColumn<PalletRouteRow> = {
  label: NOTE_LABEL,
  render: (route) => (
    <NoteCell
      note={formatRouteNotes(route)}
      pendingText={formatUnexplainedTrips(route.unexplained_trip_count)}
      maxWidth={NOTE_MAX_WIDTH}
    />
  ),
};

const routeKey = (route: PalletRouteRow) => route.route_uuid;

interface RouteTableProps {
  report: PalletRouteSummary;
  onOpenRoute: (routeUuid: string) => void;
}

/** One branch — one row per route with a trip in the range. */
export default function RouteTable({
  report,
  onOpenRoute,
}: Readonly<RouteTableProps>) {
  const openRoute = (route: PalletRouteRow) => onOpenRoute(route.route_uuid);
  const trailingColumns = [NOTE_COLUMN, detailColumn(openRoute)];

  return (
    <PalletTable
      leadColumns={LEAD_COLUMNS}
      trailingColumns={trailingColumns}
      rows={report.rows}
      rowKey={routeKey}
      totals={report.summary}
    />
  );
}
